import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from "styled-components";
import { Typo } from "../../typography";
import { Link } from "../../link";
import { RegionSelectContainer, StyledSpan } from "./RegionSelect.styles";
export const RegionSelect = ({ title, region, target, onClick, previewId, }) => {
    const theme = useTheme();
    return (_jsxs(RegionSelectContainer, Object.assign({ "data-preview-id": previewId }, { children: [_jsx(Typo, Object.assign({ size: { xsmall: theme.fontTokens.font12 }, fontWeight: theme.fontWeights.bold, tag: "strong" }, { children: title })), target ? (_jsx(Link, { alignByContent: "left", text: region, target: target, href: target, standardFontSize: true, onClick: onClick, stylingType: "primary" })) : (_jsx(StyledSpan, { children: region }))] })));
};
